import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminRecommendationApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

export function useChildRecommendations(childId: number | null) {
  return useQuery({
    queryKey: queryKeys.adminRecommendations.child(childId!),
    queryFn: () => adminRecommendationApi.getChildRecommendations(childId!),
    enabled: childId !== null && childId > 0,
  });
}

export function useDeleteRecommendations() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ childId, date, deletionType }: { childId: number; date: string; deletionType: 'hard' | 'soft' }) =>
      adminRecommendationApi.deleteRecommendationsByDate(childId, date, deletionType),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.adminRecommendations.child(variables.childId),
      });
    },
  });
}
